module.exports = "/assets/16e74b48c3fd9a679651ab077846ec86.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BT.png
// module id = 2371
// module chunks = 0